import React from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Row from "../../common/Row";
import Fieldset from "../../common/Fieldset";
import TextInput from "../../common/TextInput";
import TextAreaInput from "../../common/TextAreaInput";
import Files from "../../common/Files";
import { getPropertyFilesComponentProps, downloadFileFromByteArray } from "../../../components/common/FilesHelperUtil";
import * as types from "../../../constants/ComponentConstants";
import Section from "../../common/Section";

const OrganisatieForm = (props) => {
    const {
        goToNext,
        model,
        onChange,
        errors,
        validationMessageType,
        nameHasFocus,
        onChangeFile,
        onDropFile,
        onRemoveFile
    } = props;

    const logoFilesMimeTypes = 'image/png, image/jpeg, image/gif, image/bmp';
    const logoFilesExtensions = 'jpg, gif, bmp, png';

    let logoFilesProps = getPropertyFilesComponentProps("Logo", types.FileComponentNames.LOGO, null, model.logo && model.logo.content ? [model.logo] : [], [], false, onDropFile, onRemoveFile, onChangeFile, {
        mimeTypes: logoFilesMimeTypes,
        extensions: logoFilesExtensions
    }, null, null, null, null, 6, "white");

    logoFilesProps.showImage = true;
    logoFilesProps.imageContent = model.logo ? model.logo.content : null;
    logoFilesProps.optional = true;

    if (model.logo)
        logoFilesProps["downloadFunction"] = () => downloadFileFromByteArray(model.logo.name, model.logo.content);

    const documentatieFilesMimeTypes = 'application/pdf';
    const documentatieFilesExtensions = 'pdf';

    const documentatieFilesProps = getPropertyFilesComponentProps("Documentatie", types.FileComponentNames.DOCUMENTATIE, null, model.documentatie && model.documentatie.content ? [model.documentatie] : [], [], false, onDropFile, onRemoveFile, onChangeFile, {
        mimeTypes: documentatieFilesMimeTypes,
        extensions: documentatieFilesExtensions
    }, null, null, null, null, 6, "white");

    if (model.documentatie)
        documentatieFilesProps["downloadFunction"] = () => downloadFileFromByteArray(model.documentatie.name, model.documentatie.content);

    documentatieFilesProps.optional = true;

    return (
        <Section>
            <Form
                name="organisatie"
                headerVisible={false}
                isNotRequired
                rightButtonLabel="Ga verder"
                onRightButtonClick={goToNext}
            >
                <Fieldset>
                    <Row><div style={{ color: "#082b42", fontSize: "1.4375rem", fontWeight: "500", lineHeight: "28px", margin: "30px 0.83333% 0 0.83333%" }}>Organisatiegegevens</div></Row>
                </Fieldset>
                <div style={{ width: "100%", height: "1px", backgroundColor: "#E6E6E6", marginTop: "30px" }}></div>
                <Fieldset>
                    <Row>
                        <TextInput
                            name="naam"
                            label="Naam"
                            value={model.naam}
                            onChange={onChange}
                            validationMessage={errors ? errors['naam'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                            hasFocus={nameHasFocus}
                        />
                        <TextInput
                            name="afkorting"
                            label="Afkorting"
                            value={model.afkorting}
                            onChange={onChange}
                            validationMessage={errors ? errors['afkorting'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                            optional
                        />
                    </Row>
                    <Row>
                        <TextInput
                            name="telefoon"
                            label="Telefoon"
                            value={model.telefoon}
                            onChange={onChange}
                            validationMessage={errors ? errors['telefoon'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                            optional
                        />
                        <TextInput
                            name="gsm"
                            label="GSM"
                            value={model.gsm}
                            onChange={onChange}
                            validationMessage={errors ? errors['gsm'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                            optional
                        />
                    </Row>
                    <Row>
                        <TextInput
                            name="email"
                            label="Email"
                            value={model.email}
                            onChange={onChange}
                            validationMessage={errors ? errors['email'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                            optional
                        />
                        <TextInput
                            name="website"
                            label="Website"
                            value={model.website}
                            onChange={onChange}
                            validationMessage={errors ? errors['website'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                            optional
                        />
                    </Row>
                    <Row>
                        <TextAreaInput
                            name="extraGegevens"
                            label="Extra Gegevens"
                            value={model.extraGegevens}
                            onChange={onChange}
                            validationMessage={errors ? errors['extraGegevens'] : ""}
                            validationMessageType={validationMessageType}
                            size={12}
                            optional
                        />
                    </Row>
                    <Row>
                        <Files {...logoFilesProps} maxFileLimit={1} />
                        <Files {...documentatieFilesProps} maxFileLimit={1} />
                    </Row>
                </Fieldset>
            </Form>
        </Section>
    );
};

OrganisatieForm.propTypes = {
    goToNext: PropTypes.func,
    model: PropTypes.object,
    onChange: PropTypes.func,
    errors: PropTypes.object,
    validationMessageType: PropTypes.string,
    nameHasFocus: PropTypes.bool,
    onChangeFile: PropTypes.func,
    onDropFile: PropTypes.func,
    onRemoveFile: PropTypes.func
};

export default OrganisatieForm;